export class Arquivo {
  nmArquivo: string;
  extensaoArquivo: string;
  arquivoBase64: string;
  nuControle: string;
  cdUsuario: string;
}
